import { render, staticRenderFns } from "./newMass.vue?vue&type=template&id=ebd3ff94&"
import script from "./newMass.vue?vue&type=script&lang=js&"
export * from "./newMass.vue?vue&type=script&lang=js&"
import style0 from "./newMass.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports